// Grupos de costos de las fórmulas derivadas. TODO costo resta sin importar
// el super_type (D3, docs/PLAN_ESTADO_RESULTADOS_PRODUCTOS.md): las claves
// del otro tipo de negocio vienen vacías del backend y restan 0 (Servicios no
// tiene costos_productos/variables/fijos y viceversa), así que una sola
// aritmética sirve para ambos — lo que cambia por super_type es qué filas se
// MUESTRAN (`all_keys`). Espejo de `_margin_spec` en
// use_cases/financial_report/profitability.py.
const GROSS_COSTS = ['costos_productos', 'costos_variables', 'costos_directos'];
const GROSS_AND_FIXED = [...GROSS_COSTS, 'costos_fijos'];
const OPERATIONAL_EXPENSES = ['gastos_administracion', 'gastos_comerciales', 'gastos_i+d'];

export const INITIAL_TABLE_HEADERS = {
    "ventas_netas": {
        label: 'Ventas Netas',
        isMoney: true,
        keysSum: ['ventas_netas'],
        itemsDict: {},
        items: []
    },
    "costos_productos": {
        label: 'Costos de Productos',
        isMoney: true,
        keysSum: ['costos_productos'],
        itemsDict: {},
        items: []
    },
    "margen_producto": {
        label: 'Margen Producto %',
        isMoney: false,
        theme: 'theme_row_blue',
        keysSum: ['ventas_netas'],
        keysSubtract: ['costos_productos'],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "costos_variables": {
        label: 'Costos Variables',
        isMoney: true,
        keysSum: ['costos_variables'],
        itemsDict: {},
        items: []
    },
    "costos_directos": {
        label: 'Costos Directos',
        isMoney: true,
        keysSum: ['costos_directos'],
        itemsDict: {},
        items: []
    },
    "margen_bruto": {
        label: 'Margen Bruto %',
        isMoney: false,
        theme: 'theme_row_blue',
        keysSum: ['ventas_netas'],
        keysSubtract: GROSS_COSTS,
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "costos_fijos": {
        label: 'Costos Fijos',
        isMoney: true,
        keysSum: ['costos_fijos'],
        itemsDict: {},
        items: []
    },
    "margen_contribucion": {
        label: 'Margen Contribución %',
        isMoney: false,
        theme: 'theme_row_azure',
        keysSum: ['ventas_netas'],
        keysSubtract: GROSS_AND_FIXED,
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "gastos_totales": {
        label: 'Gastos Totales',
        isMoney: true,
        hasChilds: true,
        keysSum: ['gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
        itemsDict: {},
        items: []
    },
    "gastos_administracion": {
        label: 'Gastos Administración',
        isMoney: true,
        isShowed: false,
        theme: 'nobreak theme_row_detail_bills ',
        keysSum: ['gastos_administracion'],
        itemsDict: {},
        items: []
    },
    "gastos_comerciales": {
        label: 'Gastos Comerciales',
        isMoney: true,
        isShowed: false,
        theme: 'theme_row_detail_bills nobreak',
        keysSum: ['gastos_comerciales'],
        itemsDict: {},
        items: []
    },
    "gastos_i+d": {
        label: 'Gastos I+D',
        isMoney: true,
        isShowed: false,
        theme: 'theme_row_detail_bills',
        keysSum: ['gastos_i+d'],
        itemsDict: {},
        items: []
    },
    "gastos/ventas_%": {
        label: 'Gastos/Ventas %',
        isMoney: false,
        theme: 'theme_row_yellow',
        keysSum: ['gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "EBITDA": {
        label: 'EBITDA',
        isMoney: true,
        keysSum: ['ventas_netas'],
        keysSubtract: [...GROSS_AND_FIXED, ...OPERATIONAL_EXPENSES],
        itemsDict: {},
        items: []
    },
    "margen_EBITDA_%": {
        label: 'Margen EBITDA %',
        isMoney: false,
        theme: 'theme_row_purple',
        keysSum: ['ventas_netas'],
        keysSubtract: [...GROSS_AND_FIXED, ...OPERATIONAL_EXPENSES],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "no_operacional": {
        label: 'No Operacional',
        isMoney: true,
        keysSum: ['ingresos_no_operacional'],
        keysSubtract: ['gastos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "ingresos_no_operacional": {
        label: 'Ingresos No Operacional',
        isMoney: true,
        keysSum: ['ingresos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "gastos_no_operacional": {
        label: 'Gastos No Operacional',
        isMoney: true,
        keysSum: ['gastos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "utilidad_antes_de_impuestos": {
        label: 'Utilidad Antes de Impuestos',
        isMoney: true,
        keysSum: ['ventas_netas', 'ingresos_no_operacional'],
        keysSubtract: [...GROSS_AND_FIXED, ...OPERATIONAL_EXPENSES, 'gastos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "margen_neto_%": {
        label: 'Margen Neto %',
        isMoney: false,
        theme: 'theme_row_orange',
        keysSum: ['ventas_netas', 'ingresos_no_operacional'],
        keysSubtract: [...GROSS_AND_FIXED, ...OPERATIONAL_EXPENSES, 'gastos_no_operacional'],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    // Variantes en DINERO de los escalones de margen. Las consume solo la
    // tabla de Rentabilidad (que muestra cada escalón como pareja monto + %);
    // en Resultados quedan ocultas porque el backend nunca las incluye en
    // `all_keys` (isShowed=false). Misma aritmética que su fila porcentual.
    "margen_producto_amount": {
        label: 'Margen Producto',
        isMoney: true,
        keysSum: ['ventas_netas'],
        keysSubtract: ['costos_productos'],
        itemsDict: {},
        items: []
    },
    "margen_bruto_amount": {
        label: 'Margen Bruto',
        isMoney: true,
        keysSum: ['ventas_netas'],
        keysSubtract: GROSS_COSTS,
        itemsDict: {},
        items: []
    },
    "margen_contribucion_amount": {
        label: 'Margen Contribución',
        isMoney: true,
        keysSum: ['ventas_netas'],
        keysSubtract: GROSS_AND_FIXED,
        itemsDict: {},
        items: []
    },
};

export const CALCULATED_KEYS = [
    'margen_producto', 'margen_bruto', 'margen_contribucion',
    'margen_producto_amount', 'margen_bruto_amount', 'margen_contribucion_amount',
    'gastos_totales', 'gastos/ventas_%',
    'EBITDA', 'margen_EBITDA_%', 'no_operacional', 'utilidad_antes_de_impuestos',
    'margen_neto_%'
];

export const PERIOD_TYPES = [
    { value: "lastYear", label: "Último año" },
    { value: "last24months", label: "Últimos 24 Meses" },
    { value: "actualYear", label: "Año Actual" },
    { value: "previousYear", label: "Año Anterior" },
];

// Granularidad de bucketing aplicada en todos los reportes financieros
// (Resultados, Ventas, Gastos). Los `id` deben coincidir con los valores
// aceptados por el helper backend `resolve_trunc_params`.
export const FILTER_PERIOD_OPTIONS = [
    { id: "month", label: "Mensual" },
    { id: "quarter", label: "Trimestral" },
    { id: "ytd", label: "YTD" },
    { id: "year", label: "Anual" },
];

// Cantidad de clientes top que aparecen como series propias en el stacked
// bar chart del header de Ventas. El resto colapsa en una serie "Otros".
// Definido acá para que el día que sea configurable por usuario o por
// pantalla, haya una sola variable a reemplazar.
export const TOP_CLIENTS_COUNT = 7;

export const EXPENSE_COUNTERPART_TYPES = [
    { id: 'proveedores', label: 'Proveedores' },
    { id: 'remuneraciones', label: 'Remuneraciones' },
    { id: 'honorarios', label: 'Honorarios' },
    { id: 'internacional', label: 'Internacional' },
    { id: 'recibo', label: 'Recibo' },
    { id: 'finiquito', label: 'Finiquito' },
];

// Costos comparte tipos de contraparte con Gastos (Proveedores, Remuneraciones,
// etc.). Se exporta como alias para que los consumidores de Costos no importen
// la constante con prefijo EXPENSE_ y el día que diverjan no haya cambios en
// cascada.
export const COST_COUNTERPART_TYPES = EXPENSE_COUNTERPART_TYPES;

export const ASSET_COUNTERPART_TYPES = [
    { id: 'proveedores', label: 'Proveedores' },
    { id: 'internacional', label: 'Internacional' },
    { id: 'recibo', label: 'Recibo' },
];

// Pasivos: la contraparte de una obligación es mayoritariamente el proveedor /
// honorario / trabajador al que se le debe. Patrimonio no agrupa por contraparte
// (el tab pasa [] y oculta el multiselect).
export const LIABILITY_COUNTERPART_TYPES = [
    { id: 'proveedores', label: 'Proveedores' },
    { id: 'honorarios', label: 'Honorarios' },
    { id: 'remuneraciones', label: 'Remuneraciones' },
    { id: 'internacional', label: 'Internacional' },
    { id: 'recibo', label: 'Recibo' },
    { id: 'finiquito', label: 'Finiquito' },
];

// No Operacional usa un selector de contraparte flat (radio-style, no
// multi-select), por eso se listan todos los tipos que admite el tab.
// Mantener orden consistente con la imagen del diseño.
// Clientes y Nota de Ingreso son los tipos del lado INGRESO: sin ellos, los
// ingresos no operacionales eran inalcanzables en modo contraparte (el
// backend filtra final_sql_counterpart_type = ANY(tipos elegidos)).
export const NON_OPERATIONAL_COUNTERPART_TYPES = [
    { id: 'proveedores', label: 'Proveedores' },
    { id: 'honorarios', label: 'Honorarios' },
    { id: 'internacional', label: 'Internacional' },
    { id: 'recibo', label: 'Recibo' },
    { id: 'clientes', label: 'Clientes' },
    { id: 'nota-venta', label: 'Nota de Ingreso' },
];

export const EXPENSE_CARD_PROGRESS_COLORS = [
    'var(--progress-bar-1)',
    'var(--progress-bar-2)',
    'var(--progress-bar-3)',
];

export const COST_CARD_PROGRESS_COLORS = EXPENSE_CARD_PROGRESS_COLORS;
export const ASSET_CARD_PROGRESS_COLORS = EXPENSE_CARD_PROGRESS_COLORS;

// No Operacional usa los mismos slots --progress-bar-{1,2,3}, pero el orden
// tiene significado semántico: 1 = Ingresos (violet), 2 = Gastos (coral).
// No es una gradiente — son colores opuestos. Si el backend devuelve los
// breakdown items en orden distinto, el tab debe reordenarlos por key.
export const NON_OPERATIONAL_CARD_PROGRESS_COLORS = [
    'var(--progress-bar-1)',
    'var(--progress-bar-2)',
    'var(--progress-bar-3)',
];

// Rentabilidad usa 5 slots porque los items de breakdown son escalones de margen
// (Producto / Bruto / Contribución / EBITDA / Neto) y cada uno tiene identidad
// cromática propia (ver _report_themes.scss). El orden importa: coincide con el
// orden de los items en buildProfitabilityCard.
export const PROFITABILITY_CARD_PROGRESS_COLORS = [
    'var(--progress-bar-1)',
    'var(--progress-bar-2)',
    'var(--progress-bar-3)',
    'var(--progress-bar-4)',
    'var(--progress-bar-5)',
];

export const REPORT_DETAILS_CONFIG = [
    {
        label: 'Crecimiento',
        value: '% MoM',
        theme: 'themePercentGreen',
        key: 'ventas_netas'
    }, {
        label: 'Margen Bruto',
        value: '%',
        theme: 'themePercentBlue',
        key: 'margen_bruto'
    }, {
        label: 'Eficiencia',
        value: '%',
        theme: 'themePercentOrange',
        key: 'gastos/ventas_%'
    }, {
        label: 'Margen EBITDA',
        value: '%',
        theme: 'themePercentPurple',
        key: 'margen_EBITDA_%'
    }
];
